export enum DEVICE_CONFIGURATION_TABS_VALUES {
  ENV_VARIABLES,
  DEFAULT_RELEASES,
}

export const DEVICE_CONFIGURATION_TABS: Array<Readonly<{ name: string; value: number }>> = [
  { name: 'Environment Variables', value: DEVICE_CONFIGURATION_TABS_VALUES.ENV_VARIABLES },
  { name: 'Default Releases', value: DEVICE_CONFIGURATION_TABS_VALUES.DEFAULT_RELEASES },
];
